import React, { useState, ChangeEvent, FormEvent } from 'react';
import { PRODUCTS, CONTACT_INFO } from '../data/constants';
import { useIntersectionObserver } from '../hooks/useIntersectionObserver';
import type { ContactFormState } from '../types';

const INIT: ContactFormState = { fullName: '', company: '', email: '', phone: '', product: '', message: '' };

const Contact: React.FC = () => {
  const { setRef, isVisible } = useIntersectionObserver();
  const [form, setForm] = useState(INIT);
  const [sent, setSent] = useState(false);
  const onChange = (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) =>
    setForm(p => ({ ...p, [e.target.name]: e.target.value }));
  const onSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault(); setSent(true);
    setTimeout(() => setSent(false), 4000); setForm(INIT);
  };

  return (
    <section id="contact" ref={setRef('contact')} className="contact-section">
      <div style={{ maxWidth: 1320, margin: '0 auto' }}>

        {/* Header */}
        <div className={`sf ${isVisible('contact') ? 'vis' : ''}`} style={{ textAlign: 'center', maxWidth: 560, margin: '0 auto 56px' }}>
          <div className="eyebrow-dark" style={{ justifyContent: 'center' }}>Contact us</div>
          <h2 className="section-h2">Contacts Information</h2>
          <p style={{ fontSize: 16, color: '#718096', lineHeight: 1.7 }}>
            Our engineering team responds within 24 hours with technical guidance and competitive pricing for your GRP project.
          </p>
        </div>

        <div className="contact-inner">
          {/* Left: info */}
          <div className={`sf ${isVisible('contact') ? 'vis' : ''}`} style={{ transitionDelay: '0.1s' }}>
            <h3 style={{ fontSize: 22, fontWeight: 700, color: '#1a2b4a', marginBottom: 28 }}>
              Let's Discuss Your Project
            </h3>
            {CONTACT_INFO.map(c => (
              <div key={c.label} className="contact-info-item">
                <div className="contact-info-icon">{c.icon}</div>
                <div>
                  <div className="contact-info-label">{c.label}</div>
                  <div className="contact-info-value">{c.value}</div>
                </div>
              </div>
            ))}
            {/* Map placeholder */}
            <div style={{ marginTop: 28, background: '#e8f0fb', borderRadius: 4, height: 160, display: 'flex', alignItems: 'center', justifyContent: 'center', border: '1px solid #d0ddf0' }}>
              <div style={{ textAlign: 'center' }}>
                <iframe 
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3603.023576616173!2d55.54875869999999!3d25.437475300000003!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x76b7c9e63096cb5%3A0xea729da039b8a51!2sGulf%20Fibertech%20Industries%20LLC!5e0!3m2!1sen!2sin!4v1775581400337!5m2!1sen!2sin" 
                  width="600" 
                  height="450" 
                  style= {{border:0}} 
                  allowFullScreen
                  loading="lazy" 
                  referrerPolicy="no-referrer-when-downgrade">

                  </iframe>
                {/* <div style={{ fontSize: 32, marginBottom: 8 }}>📍</div>
                <div style={{ fontSize: 11, fontWeight: 700, color: '#1a2b4a', letterSpacing: '0.12em', textTransform: 'uppercase' }}>United Arab Emirates</div> */}
              </div>
            </div>
          </div>

          {/* Right: form */}
          <div className={`sf ${isVisible('contact') ? 'vis' : ''}`} style={{ transitionDelay: '0.2s' }}>
            <div className="contact-form-wrap">
              <h3 style={{ fontSize: 20, fontWeight: 700, color: '#1a2b4a', marginBottom: 28 }}>Request a Quote</h3>
              {sent && (
                <div style={{ background: '#edfaf3', border: '1px solid #a3e6c5', color: '#1a8a55', padding: '13px 16px', marginBottom: 20, fontSize: 14, fontWeight: 500, borderRadius: 4 }}>
                  ✓ Sent! Our team will respond within 24 hours.
                </div>
              )}
              <form onSubmit={onSubmit}>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14, marginBottom: 14 }}>
                  <div><label className="contact-label">Full Name *</label><input className="contact-input" name="fullName" value={form.fullName} onChange={onChange} placeholder="Your full name" required /></div>
                  <div><label className="contact-label">Company</label><input className="contact-input" name="company" value={form.company} onChange={onChange} placeholder="Company name" /></div>
                </div>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14, marginBottom: 14 }}>
                  <div><label className="contact-label">Email *</label><input className="contact-input" name="email" type="email" value={form.email} onChange={onChange} placeholder="your@email.com" required /></div>
                  <div><label className="contact-label">Phone</label><input className="contact-input" name="phone" value={form.phone} onChange={onChange} placeholder="+971 (0) 6749 4721" /></div>
                </div>
                <div style={{ marginBottom: 14 }}>
                  <label className="contact-label">Product of Interest</label>
                  <select className="contact-input contact-select" name="product" value={form.product} onChange={onChange}>
                    <option value="">Select a product</option>
                    {PRODUCTS.map(p => <option key={p.title} value={p.title}>{p.title}</option>)}
                    <option value="custom">Custom Fabrication</option>
                  </select>
                </div>
                <div style={{ marginBottom: 24 }}>
                  <label className="contact-label">Project Details *</label>
                  <textarea className="contact-input" name="message" value={form.message} onChange={onChange} rows={5} placeholder="Describe your requirements, dimensions, quantities..." required style={{ resize: 'vertical' }} />
                </div>
                <button type="submit" className="btn-yellow" style={{ width: '100%', fontSize: 13, padding: '14px' }}>
                  Send Enquiry →
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
export default Contact;
